<template>
  <v-card flat>
    <h5 class="mt-10 ml-6 d-flex align-center ga-2">
      <v-icon size="22" class="mr-3">$sl-elements</v-icon>
      Moment
    </h5>
    <template v-if="elements && elements.length">
      <v-card flat class="pb-2 mb-3 mt-n2" v-for="(element, index) in elements" :key="index">
        <v-card-text>
          <div class="d-sm-flex align-center justify-space-between mb-4">
            <div class="d-flex align-center">
              <CopyToClipboard
                :text="element.name"
                always-visible
                feedbackText=""
                @on-copy="copyElement(element)"
                v-if="element"
              >
                <h5 class="no-transformed mb-0">
                  {{ element.name }}
                </h5>
              </CopyToClipboard>

              <div class="d-flex align-center">
                <v-icon size="18" class="ml-1" @click="editElement(element)">$sl-edit</v-icon>
              </div>
            </div>
            
            <div>
              <v-btn  :disabled="index==0" outlined class="mr-4" @click="moveElementUp(element.id)"><v-icon size="20" class="mr-3">$sl-arrow-up</v-icon>Upp</v-btn>
              <v-btn :disabled="index==elements.length-1" outlined @click="moveElementDown(element.id)"><v-icon size="20" class="mr-3">$sl-arrow-down</v-icon>Ned</v-btn>
            </div>
        </div>
          <p class="overline small">Momentbeskrivning</p>
          <p class="mt-n4" v-if="element.description">
            {{ element.description }}
          </p>
          <v-switch
            v-model="switches[element.id]"
            :class="'gray'"
            label="Detta delmoment kräver minst antal godkända delmoment."
          ></v-switch>
          <div class="d-md-flex align-center pb-2 ml-12 mt-n6 mb-5" v-if="switches[element.id]">
            <div class="d-flex align-center pb-2">
              <div style="min-width: 280px">Lärlingen ska vara godkänd på minst</div>
              <div class="txtQty">
                <v-text-field
                  @change="changeRequiredQty(element)"
                  type="number"
                  min="0"
                  :max="element.subElements ? element.subElements.length : 0"
                  v-model="element.numSubElementsRequired"
                  :rules="requiredQtyRules"
                  label
                ></v-text-field>
              </div>
          </div><div class="align-center pb-2">
            praktiska delmoment för att momentet ska vara avklarat.</div>
          </div>

          
          <v-data-table
            :headers="[
              {text: 'Delmoment', value: 'name', sortable: false},
              {text: 'Oblig', value: 'required', sortable: false},
              {text: 'Nivå godk.', value: 'requiredLevel', sortable: false},
              {text: 'Text nivå 1', value: 'level1Text', sortable: false},
              {text: 'Text nivå 2', value: 'level2Text', sortable: false},
              {text: 'Text nivå 3', value: 'level3Text', sortable: false},
              {text: 'Text nivå 4', value: 'level4Text', sortable: false},
              {text: 'Sortera', value: 'order', sortable: false, align: 'center'},
              {text: '', value: 'action', sortable: false}
            ]"
            :items="element.subElements"
            sort-by="order"
            class="mb-4 elementsTable mt-6"
            mobile-breakpoint="1100"
            hide-default-footer
          >
            <template v-slot:item.required="{item}">
              <v-checkbox
                class="mt-n1"
                hide-details
                readonly
                :false-value="false"
                :true-value="true"
                v-model="item.required"
              ></v-checkbox>
            </template>
            <template slot="item.level1Text" slot-scope="props">
              <div class="truncate" style="width: 100px">{{ props.item.level1Text }}</div>
            </template>

            <template slot="item.level2Text" slot-scope="props">
              <div class="truncate" style="width: 100px">{{ props.item.level2Text }}</div>
            </template>

            <template slot="item.level3Text" slot-scope="props">
              <div class="truncate" style="width: 100px">{{ props.item.level3Text }}</div>
            </template>

            <template slot="item.level4Text" slot-scope="props">
              <div class="truncate" style="width: 100px">{{ props.item.level4Text }}</div>
            </template>

            <template v-slot:item.action="{item}">
              <div style="width: 200px">
                <v-btn text @click="editSubElement(element.id, item)">
                  <v-icon class="mr-1">$sl-edit</v-icon>Ändra
                </v-btn>

                <v-btn text @click="deleteSubElement(element.id, item.id)"> <v-icon>$sl-delete</v-icon>Radera </v-btn>
              </div>
            </template>
            <template v-slot:item.order="{item}">
              <div class="justify-center" style="width: 100px">
                <!-- <v-btn disabled small icon v-if="item.order===1"></v-btn> -->
                <v-btn style="width: unset !important; padding: 0 3px !important" @click.stop="moveUp(element.id, item.id)" small icon v-if="item.order > 1">
                  <v-icon small>$sl-arrow-up</v-icon>
                </v-btn>
                <v-btn style="width: unset !important; padding: 0 3px !important"
                  @click.stop="moveDown(element.id, item.id)"
                  small
                  icon
                  v-if="item.order < element.subElements.length"
                >
                  <v-icon small>$sl-arrow-down</v-icon>
                </v-btn>
                {{ item.order }}
              </div>
            </template>
            <template v-slot:item.rev="{item}">
              <a v-on:click.stop.prevent="openRevModal(item.id)">{{ item.revision }}</a>
            </template>
          </v-data-table>
          <div class="justify-space-between d-flex mt-8">
            <v-btn @click="addSubElement(element.id)">
              <v-icon class="mr-2">mdi-table-row</v-icon>Lägg till delmoment
            </v-btn>
            <v-btn color="secondary" @click="deleteElement(element.id)">
              <v-icon class="mr-2">$sl-delete</v-icon>Radera moment
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <v-card-text class="text-right" flat>
      <v-btn @click="addElement"> <v-icon>$sl-add</v-icon>Lägg till nytt moment </v-btn>
    </v-card-text>

    <v-dialog v-model="crudDialog" max-width="900px">
      <ProviderBookElementsModal
        @save="saveSubElement"
        @close="closeCrudDialog"
        :editedItem="editedItem"
      ></ProviderBookElementsModal>
    </v-dialog>
    <v-dialog v-model="elementModal" max-width="600px">
      <ElementModal
        :professionId="professionId"
        :editedItem="element"
        :reform="get(professionCourse, 'reform', '')"
        @close="closeElementModal"
        @save="updatedElement"
        @move="moveOrCopyElement"
      />
    </v-dialog>
    
    <TheCopyPasteDialog
      :is-visible="copyPasteDialogIsVisible"
      :items="elements"
      :profession-id="professionId"
      :profession-course="professionCourse"
      @close="copyPasteDialogIsVisible = false"
      @selected-items="copiedBookElements = $event"
      @on-paste="getElements()"
    />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import sortBy from 'lodash/sortBy'
import omit from 'lodash/omit'
import maxBy from 'lodash/maxBy'
import ProviderBookElementsModal from '@/components/admin/book/ProviderBookElementsModal'
import ElementModal from '@/components/admin/book/ElementModal'
import ProviderBookCommonTheory from '@/components/admin/book/ProviderBookCommonTheory'
import ProviderBookElementsRevModal from '@/components/admin/book/ProviderBookElementsRevModal'
import CopyToClipboard from '@/components/common/CopyToClipboard.vue'
import TheCopyPasteDialog from '@/components/dialog/copy-paste/TheCopyPasteDialog.vue'
import get from 'lodash/get'

// @group Ebook
// Styled EducationStart component
export default {
  name: 'ProviderBookElements',

  props: {
    //profession Id
    professionId: {
      // `Number`
      type: Number,
      // The default value is: `null`
      default: null
    },
    //course id
    professionCourse: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    ProviderBookElementsModal,
    ProviderBookElementsRevModal,
    ProviderBookCommonTheory,
    ElementModal,
    CopyToClipboard,
    TheCopyPasteDialog
  },

  data: () => ({
    crudDialog: false,
    elementModal: false,
    editedItem: {},
    switches: [],
    requiredQty: null,
    requiredQtyRules: [v => !!v || '', v => !v || Number.isInteger(Number.parseInt(v)) || ''],
    elements: [],
    element: {},
    copiedBookElements: JSON.parse(sessionStorage.getItem('byn4_course_elements')) || [],
    copyPasteDialogIsVisible: false
  }),

  watch: {
    professionId: function () {
      this.getElements()
    },
    'professionCourse.id': function () {
      this.getElements()
    },
    copiedBookElements: {
      handler(newVal) {
        sessionStorage.setItem('byn4_course_elements', JSON.stringify(newVal))
      }
    }
  },

  created() {
    this.getElements()
  },

  methods: {
    get,

    getElements() {
      API.getProfessionCoursePracticalCourses(get(this, 'professionCourse.id', ''))
        .then(res => {
          this.elements = sortBy(res.data, [function (s){return s.order}])
          this.elements.forEach(
            e => (this.switches[e.id] = Boolean(e.numSubElementsRequired && e.numSubElementsRequired > 0))
          )
        })
        .catch(err => {
          console.log(err)
        })
    },

    changeRequiredQty(el) {
      console.log(el.id, el.numSubElementsRequired)
      API.updateElement(el.id, {
        data: {numSubElementsRequired: el.numSubElementsRequired}
      })
        .then(res => {
          //- Nada
        })
        .catch(err => {
          console.log(err)
        })
    },

    closeCrudDialog() {
      this.crudDialog = false
    },
    closeElementModal() {
      this.elementModal = false
    },
    updatedElement(el){
      this.elementModal = false
    },
    /**
     * @vuese
     * Used to fetch update sub element if it exist or else create a new one
     * @arg The argument is an integer value representing if of the element and the new object of the element itself
     */
    saveSubElement(edited) {
      this.editedItem = edited

      const elIdx = findIndex(this.elements, e => {
        return e.id == this.editedItem.elementId
      })

      if (this.editedItem.id) {
        //- Find and update item
        const itIdx = findIndex(this.elements[elIdx].subElements, se => {
          return se.id === this.editedItem.id
        })

        API.updateSubElement(this.editedItem.elementId, this.editedItem.id, {
          data: this.editedItem
        })
          .then(res => {
            this.elements[elIdx].subElements[itIdx] = JSON.parse(JSON.stringify(this.editedItem))
            this.crudDialog = false
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        //- Add subElements array if not there
        if (!(this.elements[elIdx].subElements && Array.isArray(this.elements[elIdx].subElements))) {
          this.elements[elIdx].subElements = []
        }

        //- Add item at the end
        const maxOrder = maxBy(this.elements[elIdx].subElements, function (o) {
          return o.order
        })
        this.editedItem.order = maxOrder ? maxOrder.order + 1 : 1
        // Create new
        API.createSubElement(this.editedItem.elementId, {data: this.editedItem})
          .then(res => {
            //- Grab id from res
            this.editedItem.id = res.data.id
            this.elements[elIdx].subElements.push(JSON.parse(JSON.stringify(this.editedItem)))
            this.crudDialog = false
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    editElement(element){      
      this.element=element
      this.elementModal=true
    },
    addSubElement(elId) {
      this.crudDialog = true
      this.editedItem = {
        elementId: elId,
        id: null,
        name: null,
        order: null,
        required: false,
        requiredLevel: 0,
        level1Text: '',
        level2Text: '',
        level3Text: '',
        level4Text: ''
      }
    },

    editSubElement(elId, item) {
      this.crudDialog = true
      this.editedItem = JSON.parse(JSON.stringify(item))
      this.editedItem.elementId = elId
    },

    moveUp(elId, itId) {      
      this.move(elId, itId, -1)
    },

    moveDown(elId, itId) {      
      this.move(elId, itId, 1)
    },
    
    moveElementUp(elId) {      
      this.moveElement(elId, -1)
    },

    moveElementDown(elId) {      
      this.moveElement(elId, 1)
    },

    moveElement(elId, value) {
      //- Grab indexes in array
      const elIdx = findIndex(this.elements, e => {
        return e.id == elId
      })
      if (elIdx === -1) return
      
      const clickedItem = this.elements[elIdx]

      API.updateElement(elId, {data: {order: clickedItem.order + value}})
        .then(res => {
        })
        .catch(err => {
          console.log(err)
        })

      //- Find and move bumped
      const bumpedItem = this.elements[elIdx+value]
      
      if(bumpedItem){
        bumpedItem.order = clickedItem.order
        API.updateElement(bumpedItem.id, {data: {order: bumpedItem.order}})
          .then(res => {      
            this.getElements()      
          })
          .catch(err => {
            console.log(err)
          })
      }
    },

    move(elId, itId, value) {
      //- Grab indexes in array
      const elIdx = findIndex(this.elements, e => {
        return e.id == elId
      })
      if (elIdx === -1) return

      //- Find and move clicked
      const clickedItem = find(this.elements[elIdx].subElements, se => {
        return se.id === itId
      })

      clickedItem.order = clickedItem.order + value
      API.updateSubElement(elId, clickedItem.id, {data: {order: clickedItem.order}})
        .then(res => {
          //- Nada
        })
        .catch(err => {
          console.log(err)
        })

      //- Find and move bumped
      const bumpedItem = find(this.elements[elIdx].subElements, se => {
        return se.id !== itId && se.order === clickedItem.order
      })
      bumpedItem.order = bumpedItem.order - value
      API.updateSubElement(elId, bumpedItem.id, {data: {order: bumpedItem.order}})
        .then(res => {
          //- Nada
        })
        .catch(err => {
          console.log(err)
        })
    },

    moveOrCopyElement() {
      this.elementModal=false
      this.getElements()
    },

    /**
     * @vuese
     * Used to delete element
     * @arg The argument is an integer value representing element id
     */
    async deleteElement(elId) {
      const res = await this.$dialog.confirm({
        title: 'Vill du verkligen radera detta moment?',
        text: 'Samtliga tillhörande delmoment kommer också att raderas. Radering av moment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })
      if (res !== true) return

      API.deleteElement(elId)
        .then(res => {
          //- Find in array
          const elIdx = findIndex(this.elements, e => {
            return e.id == elId
          })
          if (elIdx === -1) return
          this.elements.splice(elIdx, 1)
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * @vuese
     * Used to delete subelement
     * @arg The argument is an integer value representing subelement id
     */
    async deleteSubElement(elId, itId) {
      const res = await this.$dialog.confirm({
        title: 'Vill du verkligen radera detta delmoment?',
        text: 'Radering av delmoment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })
      if (res !== true) return

      API.deleteSubElement(elId, itId)
        .then(res => {
          const elIdx = findIndex(this.elements, e => {
            return e.id == elId
          })
          const itIdx = findIndex(this.elements[elIdx].subElements, se => {
            return se.id === itId
          })

          if (itIdx > -1) {
            const deleted = this.elements[elIdx].subElements.splice(itIdx, 1)

            // Reorder the ones left
            const items = filter(this.elements[elIdx].subElements, se => {
              return se.order > deleted[0].order
            })
            items.forEach(i => {
              API.updateSubElement(elId, i.id, {data: {order: i.order - 1}})
                .then(res => {
                  i.order = i.order - 1
                })
                .catch(err => {
                  console.log(err)
                })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * @vuese
     * Used to create an element
     * @arg The argument is an object  representing element values
     */
    async addElement() {
      let name = await this.$dialog.prompt({
        text: 'Namn',
        outlined: true,
        title: 'Ange momentets namn',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
          {text: 'Spara', key: true, icon: '$sl-check'}
        ]
      })

      if (!name || name === '') return

      API.createElement({
        data: {
          name: name,
          courseId: get(this, 'professionCourse.id', ''),
          numSubElementsRequired: null
        }
      })
        .then(res => {
          res.data.subElements = []
          this.elements.push(JSON.parse(JSON.stringify(res.data)))
        })
        .catch(err => {
          console.log(err)
        })
    },

    copyElement(element) {
      this.copyPasteDialogIsVisible = true
      if ( element == null || this.copiedBookElements.some(el => element.id === el.id) ) return
      this.copiedBookElements.push(element)
    },
  }
}
</script>

<style lang="scss">
// .elementsTable.v-data-table td,
// .elementsTable.v-data-table th {
//   margin: 0px !important;
//   padding: 4px 4px 4px 4px !important;
//   font-weight: 400;
//   min-height: 18px;
//   line-height: 1.2rem;
//   vertical-align: top !important;
// }

// .elementsTable.v-data-table td .v-input--selection-controls {
//   margin-top: 0px;
//   padding-top: 0px;
// }
</style>
